import React, { Component } from 'react';
import { Modal, DatePicker, Select, Radio, Input, Form, message, Row, Col } from 'antd';
import SearchInput from '../../common/SearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';

const { Option } = Select;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const dateFormat = 'YYYY-MM-DD';

class CreateForm extends Component {
    state = {
        diseaseList: [],
        investigationAreaList: [],
    }

    componentDidMount() {
        const {
            params: { investigationAreaId },
            form: { getFieldDecorator }
        } = this.props;
        getFieldDecorator('companyOptions', { initialValue: [] });
        this.loadAreaList();
        investigationAreaId && this.loadDiseaseList(investigationAreaId);
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllInvestigationArea,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                investigationAreaList: res.data,
            });
        });
    }

    loadDiseaseList = investigationAreaId => {
        dictCache.getDict(`DISEASE_AREA_${investigationAreaId}`, cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllDisease,
                data: { investigationAreaId },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, data => {
            this.setState({ diseaseList: data.data });
        });
    }

     // 客户名称
     companySelectChange = value => {
        const { form: { setFieldsValue } } = this.props;
        const params = {};
        if (value) {
            params.customerId = value.key;
        } else {
            params.customerId = '';
        }
        setFieldsValue({ ...params });
    }

    parseCompanyData = (res, value) => {
        const { form: { setFieldsValue } } = this.props;
        if ((res.data || res.datas) ) {
            const sourceData = res.data;
            const data = sourceData.map(item => ({
                text: `${item.customerCompanyName}`,
                value: item.customerCompanyId,
                customerJdeCode: item.customerCompanyCode,
            }));
            setFieldsValue({ companyOptions: data });
        } else {
            setFieldsValue({ companyOptions: [] });
        }
    }

    handleAreaSelect = (value) => {
        const { form: { setFieldsValue } } = this.props;
        setFieldsValue({ diseaseId: undefined });
        this.loadDiseaseList(value);
        return value;
    }

    handleDiseaseFocus = () => {
        const investigationAreaId = this.props.form.getFieldValue('investigationAreaId');
        if (!investigationAreaId) {
            message.warning('请先选择项目领域');
        }
    }

    render() {
        const { isEdit, params = {}, form: { getFieldDecorator, getFieldValue } } = this.props;
        const { userCompellation, employeeCode } = params;
        const { diseaseList, investigationAreaList } = this.state;
        const formItemLayout = {
            labelCol: {
                sm: { span: 7 },
                md: { span: 7 },
            },
            wrapperCol: {
                sm: { span: 16, offset: 1 },
                md: { span: 16, offset: 1 },
            },
        };
        const diseaseId = getFieldValue('diseaseId') || undefined;
        const customerId = getFieldValue('customerId') || undefined;
        const customerCompanyName = getFieldValue('customerCompanyName') || undefined;
        const companyOptions = getFieldValue('companyOptions') || [];
        const diseaseOption = diseaseList.map(i => <Option key={i.diseaseId}>{i.diseaseName}</Option>);
        const investigationAreaOption = investigationAreaList.map(i => <Option key={i.investigationAreaId}>{i.investigationAreaName}</Option>);
        const diseaseObj = diseaseList.find(i => i.diseaseId == diseaseId) || {};
        const isOtherDisease = diseaseObj.diseaseName == '其他';
        return (
            <Form>
                <FormItem {...formItemLayout} label="人员">
                    {`${userCompellation}[${employeeCode}]`}
                </FormItem>
                <FormItem {...formItemLayout} label="竞标时间">
                    {
                        getFieldDecorator('biddingTime', {
                            rules: [{
                                required: true,
                                message: '请选择竞标时间'
                            }],
                        })(
                            <DatePicker style={{ width: 220 }} placeholder="请选择" />
                        )
                    }
                </FormItem>
                <FormItem {...formItemLayout} label="客户名称">
                    <Row style={{ lineHeight: '26px' }}>
                        <Col span={18}>
                            {
                                getFieldDecorator('customerId', {
                                    rules: [{
                                        required: true,
                                        message: '请输入客户名称'
                                    }]
                                })(
                                    <SearchInput
                                        isEdit={isEdit}
                                        keyword='customerCompanyName'
                                        style={{ width: 220 }}
                                        placeholder="请输入客户名称检索"
                                        url={API_URL.investigation.queryCustomerCompanyByName}
                                        initValue={{ key: customerId, label: customerCompanyName }}
                                        dataSource={companyOptions}
                                        parseData={this.parseCompanyData}
                                        handleSelect={this.companySelectChange}
                                    />
                                )
                            }
                        </Col>
                    </Row>
                </FormItem>
                <FormItem {...formItemLayout} label="项目领域">
                    {
                        getFieldDecorator('investigationAreaId', {
                            rules: [{
                                required: true,
                                message: '请选择项目领域'
                            }],
                            getValueFromEvent: this.handleAreaSelect
                        })(
                            <Select style={{ width: 220 }} placeholder="请选择">
                                {investigationAreaOption}
                            </Select>
                        )
                    }
                </FormItem>
                <FormItem {...formItemLayout} label="疾病">
                    {
                        getFieldDecorator('diseaseId',  {
                            rules: [{
                                required: true,
                                message: '请选择疾病'
                            }]
                        })(
                            <Select style={{ width: 220 }} placeholder="请选择" onFocus={this.handleDiseaseFocus}>
                                {diseaseOption}
                            </Select>
                        )
                    }
                </FormItem>
                {
                    isOtherDisease &&
                    <FormItem {...formItemLayout} colon={false} label={<span>&nbsp;</span>}>
                        {
                            getFieldDecorator('diseaseOther')(
                                <Input style={{ width: 220 }} placeholder="请输入备注" />
                            )
                        }
                    </FormItem>
                }
                <FormItem {...formItemLayout} label="方案编号">
                    {
                        getFieldDecorator('planNum')(
                            <Input style={{ width: 220 }} placeholder="请输入" />
                        )
                    }
                </FormItem>
                <FormItem {...formItemLayout} label="是否竞标获单">
                    {
                        getFieldDecorator('isGetDeal',  {
                            rules: [{
                                required: true,
                                message: '请选择是否竞标获单'
                            }]
                        })(
                            <RadioGroup>
                                <Radio value='1'>是</Radio>
                                <Radio value='0'>否</Radio>
                            </RadioGroup>
                        )
                    }
                </FormItem>
            </Form>
        );
    }
}

class UpdateCompareRecord extends Component {
    state = {
        params: {},
        visible: false,
        confirmLoading: false,
    }

    show = (parentRecord, record) => {
        const { userId, userCompellation, employeeCode } = parentRecord;
        const params = {
            userId,
            ...(record || {}),
            employeeCode,
            userCompellation,
        };
        this.setState({
            params,
            isEdit: !!record,
        }, () => {
            this.getFormDom(true);
            this.setState({ visible: true });
        });
    }

    hide = () => {
        this.setState({
            visible: false
        }, () => {
            this.formDom = null;
        });
    }

    confirm = () => {
        this.formRef.validateFieldsAndScroll((errors, values) => {
            if (errors) {
                return;
            }
            const {
                biddingTime,
                customerId = '',
                companyOptions = [],
            } = values;
            if (customerId) {
                const isExist = companyOptions.some(item => item.value == customerId);
                if (!isExist) {
                    message.warning('请选择正确的客户名称');
                    return;
                }
            }

            const { isEdit, params } = this.state;
            const { userId, pmBiddingRecordId } = params;

            const saveParams = {
                userId,
                ...values,
                pmBiddingRecordId,
            };
            saveParams.biddingTime = moment(biddingTime).format(dateFormat);
            delete saveParams.companyOptions;

            this.setState({ confirmLoading: true });
            const url = isEdit ? API_URL.user.editPmBiddingRecord : API_URL.user.addPmBiddingRecord;

            const options = {
                method: 'POST',
                url,
                data: { ...saveParams },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.hide();
                    this.setState({ confirmLoading: false }, () => {
                        this.props.loadData(userId);
                    });
                },
                errorResult: () => {
                    this.setState({ confirmLoading: false });
                },
            }
            $.sendRequest(options);
        });
    }

    getFormDom = (render) => {
        const { params } = this.state;
        const newProps = {};
        const objArr = Object.entries(params);
        objArr.forEach((arr) => {
            if (arr[0] == 'biddingTime') {
                newProps[arr[0]] = {
                    value: arr[1] ? moment(arr[1]) : null,
                };
            } else if (arr[0] == 'investigationAreaId' || arr[0] == 'diseaseId' || arr[0] == 'isGetDeal') {
                newProps[arr[0]] = {
                    value: (arr[1] || arr[1] === 0) ? String(arr[1]) : undefined,
                };
            } else {
                newProps[arr[0]] = {
                    value: arr[1],
                };
            }
        });
        const mapPropsToFields = () => ({
            ...newProps,
        });
        (!this.formDom || render) && (this.formDom = Form.create({ mapPropsToFields })(CreateForm));
        return this.formDom;
    }

    render() {
        const { isEdit, confirmLoading, visible, params } = this.state;
        const CreateForms = this.getFormDom(false);
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}竞标记录`}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal EditPersonModal"
                confirmLoading={confirmLoading}
                maskClosable={false}
                width={550}
            >
                <div style={{ margin: '10px 0' }}>
                    <CreateForms
                        params={params}
                        isEdit={isEdit}
                        ref={el => this.formRef = el}
                    />
                </div>
            </Modal>
        );
    }
}

export default UpdateCompareRecord;


// WEBPACK FOOTER //
// ./src/components/user/pmInfo/UpdateCompareRecord.js